import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './landingpage.module.scss';

export default function LandingPageManager() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();
    //const auth = useSelector((state: RootState) => state.authSlice.auth);

    useEffect(() => {
    }, [])

    return (
        <>
            <div className="container">

                <h3>{t('deTranslation.landingPageManager.titel')}</h3>

                <div className={styles.cardContainer} >

                    <div className={"card " + styles["landingPageCard"]} onClick={() => navigate("/manager/profiles")}>
                        <span className={styles["landingPageCardSpan"]}>
                            <i className='bi bi-person'></i>&nbsp;Profile
                        </span>
                    </div>


                </div>
            </div>
        </>
    );
}
